export default "__VITE_ASSET__DTQWN0ug__"